<template>
  <div class="place">
    <main-content right-sidebar="true" :key="$route.fullPath">
      <div class="card-grid">
        <div class="card-grid__inner">
          <div class="card-grid__title">
            {{ activePage.heading[language.code] }}
          </div>
          <div class="grid">
            <div v-for="(card, cardIndex) in activePage.cards" :key="'card' + cardIndex" class="card">
              <div v-if="card.asset" class="card__image">
                <img :src="$store.state.assetsPath + card.asset.path" alt="">
              </div>
              <div class="card__inner">
                <div class="card__top">
                  <div class="card__sublabel">
                    {{ card.sublabel[language.code] }}
                  </div>
                  <div class="card__price">
                    {{ card.price[language.code] }}
                  </div>
                </div>
                <div class="card__label">
                  {{ card.label[language.code] }}
                </div>
                <div class="card__body" v-html="card.body[language.code]"></div>
                <div v-if="card.tags.length" class="card__tags">
                  <div
                    v-for="(tag, tagIndex) in card.tags"
                    :key="'tag' + tagIndex"
                    class="tag"
                  >
                    {{ tag }}
                  </div>
                </div>
                <div class="card__qrcode">
                  <div v-if="card.qrCode[language.code]" class="card__qr">
                    <qrcode-vue render-as="canvas" background="#fff" :value="card.qrCode[language.code]" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main-content>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import MainContent from '@/components/MainContent'

export default {
  name: 'card-grid-page',
  
  components: { MainContent, QrcodeVue },

  computed: {
    ...mapGetters([
      'activePage',
      'language',
    ]),
  },
}
</script>
<style lang="scss">
.place {
  height: 100%;
  left: 0;
  pointer-events: auto;
  position: absolute;
  top: 0;
  width: 100%;
}

.card-grid {
  display: grid;
  position: absolute;
  left: 0;
  right: 0;
  top: 20rem;
  width: 125rem;
  margin: 0 auto;

  &__inner {

  }

  &__title {
    font-size: 4rem;
    margin: 0 0 5rem;
    text-align: center;
    text-transform: uppercase;
  }
}

.grid {
  display: flex;
  gap: 4.2rem;
  flex-wrap: wrap;
  justify-content: center;
}

.card {
  background: white;
  color: #000;
  position: relative;
  height: 26.5rem;
  width: 20.5rem;
  filter: drop-shadow(0rem 0rem .5rem rgba(0, 0, 0, .75));

  &__image {
    height: 11.5rem;
    width: 100%;

    img {
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  }

  &__inner {
    padding: 1.2rem 1.3rem;
  }

  &__top {
    display: flex;
    justify-content: space-between;
  }

  &__sublabel {
    color: rgba(0, 0, 0, .65);
    font-size: .9rem;
    font-weight: 200;
  }

  &__price {
    color: rgba(0, 0, 0, .85);
    font-size: 1.1rem;
  }

  &__label {
    color: rgba(0, 0, 0, 1);
    font-size: 1.2rem;
    margin: .3rem 0 .6rem;
  }

  &__body {
    color: rgba(0, 0, 0, 1);
    font-size: .9rem;
    font-weight: 200;
    line-height: 1;
  }

  &__tags {
    display: flex;
    flex-wrap: wrap;
    font-size: .9rem;
    font-weight: 200;
    margin: 1.5rem 0 0;
    position: relative;
    width: calc(100% - 5rem);
    
    &::before {
      background-color: #000;
      content: '';
      display: block;
      height: .05rem;
      position: absolute;
      width: 2.5rem;
      top: -0.35rem;
    }

    .tag {
      color: rgba(0, 0, 0, .65);
      margin: .2rem 0 0;
      padding: 0 2rem 0 0;
      position: relative;

      &::after {
        content: '';
        background: #000;
        border-radius: 50%;
        position: absolute;
        right: .9rem;
        top: 50%;
        transform: translateY(-50%);
        height: .2rem;
        width: .2rem;
      }

      &:last-child {
        &::after {
          content: '';
          display: none;
        }
      }
    }
  }

  &__qrcode {
    height: 4rem;
  }

  &__qr {
    background: #fff;
    height: 4rem;
    right: 1rem;
    bottom: 1rem;
    padding: 0;
    position: absolute;
    width: 4rem;

    canvas {
      height: 100% !important;
      width: 100% !important;
    }
  }
}
</style>
